var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 55,
    viewBox: "0 0 44 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 55C37.3085 55 38.5 53.8085 38.5 52.25V47.1166L39.1418 47.7584C40.2416 48.8582 42.0749 48.8582 43.1751 47.7584C44.2748 46.6582 44.2748 44.8249 43.1751 43.7252L38.5 39.0501V15.5833H36.6667V37.2168L25.5749 26.125L29.6999 22H31.3502C32.9082 22 34.1002 20.8085 34.1002 19.25C34.1002 18.5168 33.8249 17.7832 33.2748 17.3249L25.7584 9.80851C24.6582 8.70833 22.9167 8.70833 21.9082 9.80851C21.3582 10.3582 21.0833 11 21.0833 11.7332V13.3834L7.88342 26.5833H6.23315C4.67509 26.5833 3.48315 27.7748 3.48315 29.3333C3.48315 30.0665 3.75842 30.8001 4.30851 31.2584L11.8249 38.7748C12.9251 39.875 14.6667 39.875 15.6751 38.7748C16.2252 38.2252 16.5 37.5833 16.5 36.8502V35.1999L21.5417 30.1582L36.6667 45.2832V52.25C36.6667 52.8001 36.3001 53.1667 35.75 53.1667H9.16667V48.5833C9.16667 47.0248 7.97518 45.8333 6.41667 45.8333H1.83333V2.75C1.83333 2.19991 2.19991 1.83333 2.75 1.83333H35.75C36.3001 1.83333 36.6667 2.19991 36.6667 2.75V6.41667H38.5V2.75C38.5 1.19149 37.3085 0 35.75 0H2.75C1.19149 0 0 1.19149 0 2.75V47.1166L7.88342 55H35.75ZM23.1915 11.0918C23.5585 10.7252 24.1082 10.7252 24.4752 11.0918L31.9916 18.6082C32.3582 18.9752 32.3582 19.5248 31.9916 19.8918C31.8085 20.0749 31.625 20.1667 31.3502 20.1667H29.6999L22.9167 13.3834V11.7332C22.9167 11.5501 23.0084 11.2748 23.1915 11.0918ZM22 15.0332L28.0501 21.0833L15.5833 33.5501L9.53324 27.5L22 15.0332ZM14.3918 37.4916C14.0248 37.8582 13.4752 37.8582 13.1082 37.4916L5.59176 29.9752C5.22518 29.6082 5.22518 29.0585 5.59176 28.6915C5.77482 28.5084 5.95833 28.4167 6.23315 28.4167H7.88342L14.6667 35.1999V36.8502C14.6667 37.0332 14.5749 37.3085 14.3918 37.4916ZM24.2917 27.4082L41.8918 45.0084C42.2584 45.375 42.2584 46.0168 41.8918 46.4752C41.5248 46.8418 40.8834 46.8418 40.4251 46.4752L22.8249 28.875L24.2917 27.4082ZM7.33333 48.5833V51.8834L3.11658 47.6667H6.41667C6.96676 47.6667 7.33333 48.0332 7.33333 48.5833Z",
    fill: "#20ACE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7734 8.51029L29.588 6.69531L30.8846 7.99154L29.0697 9.80652L27.7734 8.51029Z",
    fill: "#20ACE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5391 11.2511L34.2339 7.55664L35.5302 8.85286L31.8357 12.5473L30.5391 11.2511Z",
    fill: "#20ACE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2969 13.9899L38.8063 8.48047L40.1025 9.77714L34.5931 15.2865L33.2969 13.9899Z",
    fill: "#20ACE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.58203H24.75V6.41536H13.75V4.58203Z",
    fill: "#20ACE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57812 9.16797H19.2448V11.0013H4.57812V9.16797Z",
    fill: "#20ACE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57812 13.75H15.5781V15.5833H4.57812V13.75Z",
    fill: "#20ACE3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57812 18.332H11.9115V20.1654H4.57812V18.332Z",
    fill: "#20ACE3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57812 22.918H7.32813V24.7513H4.57812V22.918Z",
    fill: "#20ACE3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57812 41.25H30.2448V43.0833H4.57812V41.25Z",
    fill: "#20ACE3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9141 44.916H33.9141V46.7493H11.9141V44.916Z",
    fill: "#20ACE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9141 48.584H33.9141V50.4173H11.9141V48.584Z",
    fill: "#20ACE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestion);
export default __webpack_public_path__ + "static/media/gestion.0b1f8059dacd51603da299b71549da5d.svg";
export { ForwardRef as ReactComponent };